import React, { useState } from 'react';

interface NewsletterModalProps {
  open: boolean;
  onClose: () => void;
}

const NewsletterModal: React.FC<NewsletterModalProps> = ({ open, onClose }) => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  if (!open) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/)) {
      setError('Por favor, insira um e-mail válido.');
      return;
    }
    setSuccess(true);
    setEmail('');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8 max-w-sm w-full relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-2xl font-bold focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
          aria-label="Fechar modal"
        >
          ×
        </button>
        {!success ? (
          <form onSubmit={handleSubmit}>
            <h3 className="text-xl font-bold mb-2 text-gray-900 text-center">Receba novidades do TaMoAki!</h3>
            <p className="text-gray-700 mb-4 text-center">Cadastre seu e-mail para ficar por dentro de promoções e novidades.</p>
            <input
              type="email"
              className="w-full border border-gray-300 rounded px-4 py-2 mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-800 transition-shadow"
              placeholder="Seu e-mail"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              aria-label="E-mail"
              autoFocus
            />
            {error && <div className="text-red-600 text-sm mb-2 font-semibold">{error}</div>}
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded transition focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
              aria-label="Cadastrar e-mail na newsletter"
            >
              Cadastrar
            </button>
          </form>
        ) : (
          <div className="text-center">
            <h3 className="text-xl font-bold mb-2 text-green-700">Cadastro realizado!</h3>
            <p className="text-gray-700 mb-4">Obrigado por se inscrever. Em breve você receberá novidades do TaMoAki.</p>
            <button
              onClick={onClose}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded transition focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
              aria-label="Fechar modal de newsletter"
            >
              Fechar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsletterModal; 